import ChatbotModel from '@mm/state/model/ChatbotModel';

export const CHAT_WIDGET_CHANNEL_DESCRIPTIONS: Record<
  ChatbotModel['chatWidgetChannel'],
  string
> = {
  facebook: 'Facebook Messenger widget enabled',
  web_chat: 'MobileMonkey webchat enabled',
  omnichat: 'MobileMonkey OmniChat enabled',
};

export const KNOWN_SITE_TYPES = [
  'WordPress',
  'WiX',
  'Shopify',
  'Squarespace',
  'Weebly',
  'Leadpages',
  'Duda',
  'Google Tag Manager',
  'Other',
] as const;
export type KnownSiteType = typeof KNOWN_SITE_TYPES[number];
export const isKnownSiteType = (siteType?: string): siteType is KnownSiteType =>
  !!(siteType && KNOWN_SITE_TYPES.find(t => t === siteType));
